export default function (entity) {

    entity.remove('forces');
};
